import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { NavItem } from '.'
import { useStore } from '../../providers/store.provider';

const Wrapper = styled.div`
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    background: white;
    height: 100%;
`

export const NavList = ({ items }) => {

    const storeProvider = useStore();

    const [subnav, setSubnav] = useState(null);
    const [isMultistore, setIsMultistore] = useState(storeProvider.getMultistoreState());
    const [selectedMultistore, setSelectedMultistore] = useState(false);

    useEffect(() => {
        const selected = storeProvider.selectedMultistore;
        setSelectedMultistore(selected)
        setIsMultistore(storeProvider.getMultistoreState())
    }, [storeProvider])

    const showSubnav = (value) => setSubnav(value);


    useEffect(() => {
        var acc = document.getElementsByClassName("accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.display === "block") {
                    panel.style.display = "none";
                } else {
                    panel.style.display = "block";
                }
            });
        }
    }, [])

    return (
        <Wrapper>
            {items && items.map(item => {
                const disabled = isMultistore && (isMultistore && !selectedMultistore) && (item.name !== 'Clientes' && item.name !== 'Cupons' && item.name !== 'Dashboard');
                const submenu = item.submenu
                    ? item.submenu.filter((sub) => !sub.multistoreOnly || isMultistore)
                    : item.submenu;
                return !disabled ? (
                    <NavItem
                        key={`nav#${item.name}`}
                        id={item.id}
                        color={item.color}
                        icon={item.icon}
                        name={item.name}
                        link={item.link}
                        submenu={submenu}
                        subnav={subnav}
                        setSubnav={setSubnav}
                        showSubnav={showSubnav}
                        disabled={disabled}
                    />
                ) : (
                    undefined
                )
            })}
        </Wrapper>
    )
}
